import React from "react";
import { Col, Row } from "react-bootstrap";
import StockValue from "../stocks/stockValues";
const StreamingHeader = () => {
    return (React.createElement(Row, { className: "mx-0" },
        React.createElement(Col, { lg: 12, className: "px-0" },
            React.createElement(StockValue, null))));
};
export default StreamingHeader;
